import { campaignConfig } from '../../config';
import { http } from '../axios';

type UpdateCampaignSettings = {
    campaignTagLine: string;
    endDate: string;
    startDate: string;
};
export interface UpdateCampaignSettingsProps {
    campaignProductId: string;
    settings: UpdateCampaignSettings;
}
export const updateCampaignSettings = (props: UpdateCampaignSettingsProps) => {
    const { campaignProductId, settings } = props;
    const params = { pathParams: { campaignProductId } };

    return http.post<void>(campaignConfig().endpointMarketingSettings, settings, params);
};
